import React, { useState } from 'react';
import {
  Box, Button, Card, CardContent, Chip, Stack, Table, TableBody, TableCell,
  TableHead, TableRow, Typography,
} from '@mui/material';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { PageHeader } from '../../../components/admin';
import HydrantKontrolaDialog from '../../../components/hydranty/HydrantKontrolaDialog';
import { useHydrantDetailQuery, useHydrantKontrolyQuery } from '../../../api/JsdhNotifikaceService/service/HydrantBodMutations';
import { HydrantBodService } from '../../../api/JsdhNotifikaceService/service/HydrantBodService';
import { kontrolaStavColor } from './hydrantStav';

const HydrantDetailPage: React.FC = () => {
  const { id } = useParams();
  const hydrantId = id ? parseInt(id, 10) : undefined;
  const { data: detail } = useHydrantDetailQuery(hydrantId);
  const { data: kontroly } = useHydrantKontrolyQuery(hydrantId);
  const [kontrolaOpen, setKontrolaOpen] = useState(false);

  if (!detail || !hydrantId) return <Box />;
  const h = detail.hydrant;

  return (
    <Box>
      <PageHeader title={`Hydrant ${h.oznaceni}`} subtitle={h.ulice ?? ''} action={
        <Stack direction="row" spacing={1}>
          <Button startIcon={<FactCheckIcon />} variant="contained" onClick={() => setKontrolaOpen(true)}>Provést kontrolu</Button>
          <Button startIcon={<QrCode2Icon />} onClick={() => HydrantBodService.stahniQrImage(hydrantId, h.oznaceni)}>QR</Button>
        </Stack>
      } />

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 1 }}>
            <Chip label={detail.stav} color={kontrolaStavColor(detail.stav)} />
            <Typography>Typ: {h.typ || '—'} | DN: {h.dn ?? '—'}</Typography>
          </Stack>
          <Typography variant="body2">GPS: {h.lat ?? '—'}, {h.lng ?? '—'}</Typography>
          <Typography variant="body2">Vlastník: {h.vlastnik || '—'}</Typography>
        </CardContent>
      </Card>

      {detail.aktivniZavady.length > 0 && (
        <Card sx={{ mb: 3, borderLeft: '4px solid #d32f2f' }}>
          <CardContent>
            <Typography variant="subtitle1">Aktivní závady</Typography>
            {detail.aktivniZavady.map((z) => (
              <Typography key={z.id} variant="body2">• [{z.priorita}] {z.popis} ({z.stav})</Typography>
            ))}
          </CardContent>
        </Card>
      )}

      <Card>
        <CardContent>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>Historie kontrol</Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Datum</TableCell><TableCell>Kontroloval</TableCell>
                <TableCell>Stav</TableCell><TableCell>Průtok/Tlak</TableCell><TableCell>PDF</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(kontroly ?? []).map((k) => (
                <TableRow key={k.id}>
                  <TableCell>{dayjs(k.datum).format('DD.MM.YYYY HH:mm')}</TableCell>
                  <TableCell>{k.kontrolovalJmeno || '—'}</TableCell>
                  <TableCell><Chip size="small" label={k.stav} color={kontrolaStavColor(k.stav)} /></TableCell>
                  <TableCell>{k.prutokLs ?? '—'} l/s / {k.tlakBar ?? '—'} bar</TableCell>
                  <TableCell>
                    <Button size="small" onClick={() => HydrantBodService.stahniKontrolaPdf(k.id)}>PDF</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <HydrantKontrolaDialog open={kontrolaOpen} hydrantId={hydrantId} onClose={() => setKontrolaOpen(false)} />
    </Box>
  );
};

export default HydrantDetailPage;
